import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import Medusa from '@medusajs/js-sdk';
import get from 'lodash.get';
import { useTenantContext } from '@football-kids/client-lib/context/TenantContext';

const MedusaContext = createContext<Medusa>(null as unknown as Medusa);

export const MedusaContextProvider = ({ children }: PropsWithChildren) => {
    const tenantConfig = useTenantContext();
    const sdk = useMemo(() => new Medusa({
        baseUrl: get(tenantConfig, 'medusa.apiUrl')!,
        publishableKey: get(tenantConfig, 'medusa.apiPublishableKey'),
        auth: {
            type: "jwt"
        }
    }), [tenantConfig]);

    return <MedusaContext.Provider value={sdk}>
        {children}
    </MedusaContext.Provider>;
};

export const useMedusaContext = () => {


    return useContext(MedusaContext);
};
